<div class="container py-4">

  <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">
    {{ alert.message }}
  </ngb-alert>

  <app-smart-tag-configurator
    [petName]="petName"
    [freeTags]="tagPricing?.freeTags ?? null"
    [tagUnitPrice]="tagUnitPrice"
    subtitle=""
    [showQuantitySelector]="false"
    [showSingleItemBadge]="false"
    (continueFree)="onContinueFreeOnly($event)"
    (continueWithPayment)="onContinueWithPayment($event)"
  ></app-smart-tag-configurator>

</div>
